<ng-container *mobxAutorun>
  <app-ref-list [page]="query.page" [showAlarm]="false"></app-ref-list>
</ng-container>
